import React from 'react';
import { useIntl } from 'react-intl';
import styles from './TermsOfUse.module.scss';
import messages from './messages';

const TermsOfUse = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.termsText}>
      <span>{formatMessage(messages.privacyText)}</span>
      <span>
        <a
          href="https://purple.com/terms-and-privacy#section-id-privacy"
          target="_blank"
          rel="noreferrer"
        >
          {formatMessage(messages.privacyPlicyText)}
        </a>
      </span>
      <span>{formatMessage(messages.privacyConnector)}</span>
      <span>
        <a
          href="https://purple.com/terms-and-privacy"
          target="_blank"
          rel="noreferrer"
        >
          {formatMessage(messages.termsOfUse)}
        </a>
      </span>
      <span>.</span>
    </div>
  );
};

export default TermsOfUse;
